<div
  class="select-document-area"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragEnter($event)"
  (drop)="onDrop($event)"
>
  <div>
    <div class="select-document-area__attach">
      <div class="icon-container">
        <img src="assets/images/attach.svg" />
      </div>
    </div>
    <ion-button
      class="select-document-area__button content-margin-top"
      [disabled]="disabled"
      (click)="onOpenAddFileSelector($event)"
      color="primary"
      fill="outline"
      size="medium"
    >
      {{ buttonText | translate }}
    </ion-button>
    <input
      type="file"
      #fileInput
      hidden
      (change)="onSelectFile($event)"
      style="
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        top: 0;
        left: 0;
      "
    />
  </div>
  <ion-text color="medium-dark">
    <div
      *ngIf="textSubtitle"
      class="select-document-area__text-subtitle content-margin-top"
    >
      {{ textSubtitle | translate }}
    </div>
  </ion-text>
  <ion-text color="medium">
    <div
      class="select-document-area__text-info mapfre-fs-xxs-r"
      *ngIf="textInfo"
    >
      {{ textInfo | translate }}
    </div>
  </ion-text>
</div>
